import React from "react";
import { Box } from "@mui/material";
import LoginFormHeader from "./LoginFormHeader";
import LoginFormFields from "./LoginFormFields";

const LoginFormPanel = ({ login }) => {
  const {
    isMobile,
    forgotPassword,
    forgotUsername,
    needs2FA,
    setNeeds2FA,
    setPassword,
    handleBackToLogin,
    primaryColor,
  } = login;

  return (
    <Box
      sx={{
        width: isMobile ? "100%" : "40%",
        display: "flex",
        paddingTop: "4vh",
        paddingBottom: "140px",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#fafafa",
        position: "relative",
        height: "100%",
        overflowY: "auto",
        background: isMobile
          ? "white"
          : "linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)",
        "&::before": isMobile
          ? {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "transparent",
            pointerEvents: "none",
          }
          : {},
      }}
    >
      {/* Login Form Container */}
      <Box
        sx={{
          width: "90%",
          maxWidth: "480px",
          backgroundColor: "transparent",
          p: { xs: 3, sm: 4 },
          position: "relative",
          my: "auto",
        }}
      >
        {/* Company Logo */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box
            component="img"
            src="./ProbateBondPros.png"
            alt="Probate Bond Pros Logo"
            sx={{
              height: 60,
              maxWidth: "100%",
              filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.2))",
            }}
          />
        </Box>

        <LoginFormHeader
          forgotPassword={forgotPassword}
          forgotUsername={forgotUsername}
          needs2FA={needs2FA}
          setNeeds2FA={setNeeds2FA}
          setPassword={setPassword}
          handleBackToLogin={handleBackToLogin}
          primaryColor={primaryColor}
        />

        <LoginFormFields login={login} />
      </Box>
    </Box>
  );
};

export default LoginFormPanel;
